import clsx from 'clsx';
import React from 'react';

/* eslint-disable react/require-default-props */
interface LoadingSpinnerProps {
  color?: string,
  size?: number
  borderWidth?: number
  className?: string
}

export function LoadingSpinner({
  className, color = 'light', size = 22, borderWidth = 3,
}: LoadingSpinnerProps) {
  return (
    <div className={clsx('d-flex justify-content-center align-items-center', className)}>
      <div className={`spinner-border text-${color}`} role="status" style={{ width: size, height: size, borderWidth }}>
        <span className="visually-hidden">Loading...</span>
      </div>
    </div>
  );
}
